import React from "react";
import "./ReportBrandBlock.css";

/**
 * Shared organization brand block for HTML reports and admin preview.
 * Consumes a resolveOrgBranding() snapshot — no settings logic here.
 *
 * @param {{
 *   branding: import("../../helpers/resolveOrgBranding").OrgBrandingSnapshot,
 *   variant?: "print" | "preview",
 *   docTitle?: string,
 *   showDocTitle?: boolean,
 * }} props
 */
export function ReportBrandBlock({
  branding,
  variant = "print",
  docTitle,
  showDocTitle = true,
}) {
  if (!branding) {
    return null;
  }

  const isPrint = variant === "print";
  const logoClass = isPrint ? "erp-logo" : "er-logo";
  const brandNameClass = isPrint ? "erp-brand-name" : "er-brand-name";
  const contactClass = isPrint ? "erp-contact-lines" : "er-contact-lines";
  const rowClass = isPrint ? "erp-brand-row" : "er-brand-row";

  return (
    <div className={rowClass}>
      {branding.logoUrl ? (
        <img
          src={branding.logoUrl}
          alt=""
          className={logoClass}
        />
      ) : null}
      <div className="report-brand-text">
        <div className={brandNameClass}>{branding.brandName}</div>
        {branding.legalNameLine ? (
          <div className={contactClass}>
            <div className="report-contact-line">{branding.legalNameLine}</div>
          </div>
        ) : null}
        {showDocTitle && docTitle ? (
          isPrint ? (
            <h1 className="erp-title">{docTitle}</h1>
          ) : (
            <h1 className="er-title">{docTitle}</h1>
          )
        ) : null}
        {branding.contactLines.length > 0 ? (
          <div className={contactClass}>
            {branding.contactLines.map((line) => (
              <div key={line} className="report-contact-line">
                {line}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
